import styled from 'styled-components';
import { mediaBelow, pxToRem } from '../../assets/styles/helper';
import { variables } from '../../assets/styles/variables';
import themeColors from '../../assets/styles/themeColors';
import {
  uDanger,
  uFlex,
  uFlexColumn,
  uLabel,
  uPrimaryColor,
} from '../../assets/styles/utility';

const Paragraph = styled.p`
  font-weight: ${({ bold, fontWeight }) =>
    bold ? 600 : fontWeight && fontWeight};
  line-height: ${({ lineHeight }) => lineHeight && lineHeight};
  text-align: ${({ centerText }) => (centerText ? 'center' : 'unset')};
  font-size: ${({ fontSize, usePx }) => {
    if (!fontSize) return null;
    return usePx ? `${fontSize}px` : pxToRem(fontSize);
  }};
  color: ${({ color }) => color || themeColors.colorTextPrimary};
  text-decoration: ${({ textDecoration }) => textDecoration || 'initial'};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? `${pxToRem(marginBottom)}` : 0};
  margin-top: ${({ marginTop }) => (marginTop ? `${pxToRem(marginTop)}` : 0)};
  margin-left: ${({ marginLeft }) =>
    marginLeft ? `${pxToRem(marginLeft)}` : 0};
  margin-right: ${({ marginRight }) =>
    marginRight ? `${pxToRem(marginRight)}` : 0};
  ${({ isError }) => isError && uDanger};
  ${({ isColumn }) => isColumn && uFlexColumn};
  ${({ isPrimaryColor }) => isPrimaryColor && uPrimaryColor};
  ${({ labelColor }) => labelColor && uLabel};
  ${({ isFlex }) => isFlex && uFlex};
  ${({ whiteSpace }) => whiteSpace && 'white-space: nowrap'};
  ${({ disabled }) => disabled && `opacity: 0.5`};
  ${({ fullWidth }) => fullWidth && `width: 100%`};

  ${mediaBelow(variables.breakpoints.bpMd)} {
    ${({ fontSizeMobile, usePx }) => {
      if (!fontSizeMobile) return null;
      return `font-size: ${
        usePx ? `${fontSizeMobile}px` : pxToRem(fontSizeMobile)
      };`;
    }}
  }

  > strong {
    font-weight: 600;
  }

  a {
    font-weight: 600;
  }
`;

export default Paragraph;
